import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';

export const goldenCherrySystem: TickSystem<GameState, GameAction> = {
  name: 'goldenCherry',
  update: (state, _dt, _dispatch) => {
    if (!state.isRunning) return state;

    // Spawn check
    if (!state.goldenCherry.active && state.playTime >= state.goldenCherry.nextSpawnTime) {
      return {
        ...state,
        goldenCherry: { ...state.goldenCherry, active: true, endTime: state.playTime + 10 },
      };
    }

    // Expire check
    if (state.goldenCherry.active && state.playTime >= state.goldenCherry.endTime) {
      const next = state.playTime + 120 + Math.random() * 180;
      return {
        ...state,
        goldenCherry: { active: false, nextSpawnTime: next, endTime: 0 },
      };
    }

    return state;
  },
};
